import { Flow } from '@store/async';

interface IntercomMetadata {
  has_workspace?: boolean;
  has_workflow?: boolean;
  has_chatbot_workflow?: boolean;
  has_module_workflow?: boolean;
  has_voice_workflow?: boolean;
  has_sms_workflow?: boolean;
}

export const updateIntercom = (eventName: string, metadata: IntercomMetadata) => {
  window.Intercom?.('trackEvent', eventName, metadata);
};

export const updateIntercomWithWorkflows = (workflows: Flow[] = []) => {
  // Determine workflow types
  const hasVoiceWorkflow = workflows.some((flow) => flow.trigger_type === 'call.initiated');
  const hasChatbotWorkflow = workflows.some((flow) => flow.trigger_type === 'http.request');
  const hasModuleWorkflow = workflows.some((flow) => flow.trigger_type === 'workflow.module');

  // Send data to Intercom
  updateIntercom('workflow-check', {
    has_workflow: workflows.length > 0,
    has_voice_workflow: hasVoiceWorkflow,
    has_chatbot_workflow: hasChatbotWorkflow,
    has_module_workflow: hasModuleWorkflow,
  });
};
